/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import React, { useEffect, useCallback, useMemo, useState } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { get } from 'lodash-es';
import { isProduction } from "src/config/index";
import { withFormikDevtools } from "formik-devtools-extension";

import { useQuery } from 'src/utils/ReactHooksUtil';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import { useHistory } from 'react-router-dom';
import Table from 'src/components/table/Table';
import classNames from 'classnames';
import objectHash from 'object-hash';

const Render = (props) => {
    // DEV TOOL
    if (!isProduction()) {
        withFormikDevtools(props);
    }

    const {
        columns,
        searchData,
        recordsPerPage,
        onPageChange,
        hasEdit,
        editClick,
        hasRemove,
        removeAction,
        rowDeletedCheckPath,
        customActions,
        editIconClass,
        activityList,
        className,
        show,
    } = props

    return (
        <>
            <div className={classNames('card', className)}>
                {show ? (
                    <div className={classNames('card', className)}>
                        <div className="mb-2 border p-2 float-left">
                            <span className="mr-2 border badge badge-secondary status-Total mb-2">
                                <div>
                                    <label>Gross Loan</label>
                                    <div>
                                        <input className="text-center font-weight-bold text-black" type="text" value={activityList.grossLoanAmount} disabled />
                                    </div>
                                </div>
                            </span>
                            <span className="mr-2 border badge badge-secondary status-Total mb-2">
                                <div>
                                    <label>Net Loan Amount</label>
                                    <div>
                                        <input className="text-center font-weight-bold text-black" type="text" value={activityList.netLoan} disabled />
                                    </div>
                                </div>
                            </span>
                        </div>
                    </div>
                ) : null}

                <div className="card-body">
                    <Table
                        columns={columns}
                        searchData={searchData}
                        recordsPerPage={recordsPerPage}
                        onPageChange={onPageChange}
                        hasEdit={hasEdit}
                        editClick={editClick}
                        hasRemove={hasRemove}
                        removeClick={removeAction}
                        rowDeletedCheckPath={rowDeletedCheckPath}
                        customActions={customActions}
                        editIconClass={editIconClass}
                    />
                </div>
            </div>
        </>
    )
}

const SearchContainer = ({
    className,
    reducer,
    dataPath,
    action,
    redirectUrlOnEdit,
    columns,
    where,
    queryParamsAsWhere,
    hasEdit,
    editAction,
    hasRemove,
    removeAction,
    rowDeletedCheckPath,
    forceRefreshSearchContainer,
    customActions,
    fullTextSearch,
    editIconClass,
    caseSensitiveSearchProperties,
    show,
}) => {
    const query = useQuery();
    const history = useHistory();

    const queryConditions = useMemo(() => (queryParamsAsWhere ? query : where), [
        queryParamsAsWhere,
        query,
        where,
    ]);

    const dataKeyOfReducer = useMemo(() => objectHash({
        reducer,
        queryConditions,
    }), [
        reducer,
        queryConditions,
    ]);


    // REDUX
    const dispatch = useDispatch();
    const reducerData = useSelector((state) => state[reducer], shallowEqual);
    const searchData = get(reducerData, dataPath || dataKeyOfReducer);

    const activitiesFromSearch = useMemo(() => {
        if (!searchData || !searchData.data) {
            return { activities: [], grossLoanAmount: 0, netLoan: 0 };
        }

        let grossLoanAmount = 0;
        let netLoan = 0;

        searchData.data.forEach((item) => {
            const meta = item.meta;
            if (meta && meta.loanAmount != null) {
                netLoan += (meta.loanAmount ?? 0) - (meta.crossSaleAmount ?? 0) - (meta.processingFees ?? 0);
            
            }
            if (meta && meta.grossLoanAmount != null) {
                grossLoanAmount += meta.grossLoanAmount ?? 0;

            }
        });


        return {
            activities: [],
            grossLoanAmount: isNaN(grossLoanAmount) ? 0 : grossLoanAmount,
            netLoan: isNaN(netLoan) ? 0 : netLoan
          };
          
    }, [searchData]);

    useEffect(() => {
        if (action) {
            dispatch(action({
                where: queryConditions,
                caseSensitiveSearchProperties,
                currentPage: 0,
                fullTextSearch,
                dataKeyOfReducer,
            }));
        }
    }, [
        dispatch,
        queryConditions,
        action,
        forceRefreshSearchContainer,
        caseSensitiveSearchProperties,
        fullTextSearch,
        dataKeyOfReducer,
    ]);

    // PAGE CHANGE
    const onPageChange = useCallback((currentPage) => {
        dispatch(action({
            where: queryParamsAsWhere ? query : where,
            currentPage,
            fullTextSearch,
        }));
    }, [
        dispatch,
        action,
        query,
        queryParamsAsWhere,
        where,
        fullTextSearch,
    ]);

    // EDIT
    const editClick = useCallback((record) => {
        if (editAction) {
            dispatch(editAction(record));
        }
        if (redirectUrlOnEdit) {
            history.push(redirectUrlOnEdit);
        }
    }, [
        dispatch,
        editAction,
        redirectUrlOnEdit,
        history,
    ]);

    return (
        <>
            <Render
                className={className}
                columns={columns}
                searchData={searchData}
                recordsPerPage={SEARCH_RECORD_PAGE_LIMIT}
                onPageChange={onPageChange}
                hasEdit={hasEdit}
                editClick={editClick}
                hasRemove={hasRemove}
                removeAction={removeAction}
                rowDeletedCheckPath={rowDeletedCheckPath}
                customActions={customActions}
                editIconClass={editIconClass}
                activityList={activitiesFromSearch}
                show={show}
            />

        </>
        // <div className={classNames('card', className)}>
        //      <div className="mb-2 border p-2 float-left">
        //   <span className="mr-2 border badge badge-secondary status-Total mb-2">
        //       <div>
        //         <label>Gross Loan</label>
        //         <div>
        //           <input className="text-center font-weight-bold text-black" type="text" value={grossLoan} disabled
        //           />
        //         </div>
        //       </div>
        //     </span>
        //     <span className="mr-2 border badge badge-secondary status-Total mb-2">
        //       <div>
        //         <label>Net Loan Amount</label>
        //         <div>
        //           <input className="text-center font-weight-bold text-black" type="text" value={netLoan} disabled
        //           />
        //         </div>
        //       </div>
        //     </span>
        //   </div>
        //     <div className="card-body">
        //         <Table
        //             columns={columns}
        //             searchData={searchData}
        //             recordsPerPage={SEARCH_RECORD_PAGE_LIMIT}
        //             onPageChange={onPageChange}
        //             hasEdit={hasEdit}
        //             editClick={editClick}
        //             hasRemove={hasRemove}
        //             removeClick={removeAction}
        //             rowDeletedCheckPath={rowDeletedCheckPath}
        //             customActions={customActions}
        //             editIconClass={editIconClass}
        //         />
        //     </div>
        // </div>
    );
};

SearchContainer.propTypes = {
    action: PropTypes.func,
    columns: PropTypes.any,
    dataPath: PropTypes.string,
    reducer: PropTypes.string,
    hasEdit: PropTypes.bool,
    editAction: PropTypes.func,
    redirectUrlOnEdit: PropTypes.string,
    where: PropTypes.object,
    queryParamsAsWhere: PropTypes.bool,
    hasRemove: PropTypes.bool,
    removeAction: PropTypes.func,
    rowDeletedCheckPath: PropTypes.string,
    forceRefreshSearchContainer: PropTypes.any,
    className: PropTypes.string,
    customActions: PropTypes.array,
    fullTextSearch: PropTypes.bool,
    editIconClass: PropTypes.string,
    caseSensitiveSearchProperties: PropTypes.array,
};

SearchContainer.defaultProps = {
    reducer: '',
    dataPath: '',
    action: null,
    columns: [],
    hasEdit: false,
    editAction: null,
    hasRemove: false,
    removeAction: null,
    redirectUrlOnEdit: null,
    queryParamsAsWhere: true,
    where: {},
    rowDeletedCheckPath: null,
    forceRefreshSearchContainer: {},
    className: '',
    customActions: [],
    fullTextSearch: true,
    editIconClass: '',
    caseSensitiveSearchProperties: [],
};

export default SearchContainer;
